/* eslint-disable no-useless-computed-key */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback, useRef } from 'react';
import customStyles from "../../../../../assets/styles/customStyles";
import PrimaryCard from "../../../../Shared/components/Card/PrimaryCard";
import { Row, Col, Image, Space } from "antd";
import { Button, TextField, Box } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "../../../../../assets/images/icon_actions/Search Icon.svg";
import AddIcon from "../../../../../assets/images/icon_actions/Add Icon.svg";
import SettingsImg from "../../../../../assets/images/icon_menus/SettingsIcon.json";
import crudActions from "../../../../CRUD/redux/actions";
import { NavLink } from "react-router-dom";
import clsx from "clsx";
import MainHeader from "../../../../Shared/components/Header";
import { OtherTaxesTable } from "./OtherTaxesTable";
import { PrimaryDrawer } from "../../../../Shared/components/Drawer/PrimaryDrawer";
//import FilterIcon from "../../../../../assets/images/icon_actions/Filter Icon.svg";
import usePrevious from "../../../../Shared/components/Previous";
import { emptyValidation } from "../../../../../helpers/validation";
import { toast } from 'react-toastify';
import ImportIcon from "../../../../../assets/images/icon_actions/Import.svg";
import ExportIcon from "../../../../../assets/images/icon_actions/Export.svg";
import { ImportExport } from '../../../../Shared/components/ImportExport';
import { AutoCompleteComponent } from "../../../../Shared/components/AutoCompleteComponent";
import { checkViewPermission, checkCRUDPermission, checkComponentPermission } from '../../../../../helpers/utilities';

const OtherTaxes = (props) => {
    const { createDetails, createError, exportDetails, exportLoader, createLoader, editDetails, editError, editLoader, getList, getData } = useSelector(state => state.crudReducer);
    const { moduleType } = props;
    const [visible, setVisible] = useState(false);
    const [form, setForm] = useState({});
    const [view, setView] = useState(false);
    const [addMore, setAddMore] = useState(false);
    const [error, setError] = useState({});
    const [search, setSearch] = useState('');
    const [iconAnimation, setIconAnimation] = useState(false);
    const prevCreateDetails = usePrevious(createDetails);
    const prevCreateError = usePrevious(createError);
    const prevEditDetails = usePrevious(editDetails);
    const prevEditError = usePrevious(editError);
    const prevSearch = usePrevious(search);
    const timeoutRef = useRef(null);
    const [sortOrder, setSortOrder] = useState("desc");
    const [sortBy, setSortBy] = useState("id");
    const [skip, setSkip] = useState(0);
    const limit = 25;
    const [loadMore, setLoadMore] = useState(false);
    const [loadMoreContent, setLoadMoreContent] = useState(false);
    const [importVisible, setImportVisible] = useState(false);

    const { roleManagement } = useSelector(state => state.authReducer);
    const { history } = props;

    const handleOpen = () => {
        setVisible(true);
        setForm({}); setError({});
    };
    const handleClose = () => {
        setVisible(false);
        setForm({}); setError({});
    };

    const dispatch = useDispatch();


    useEffect(() => {
        if ((prevSearch !== undefined && search && search?.length > 2 && prevSearch !== search) || (prevSearch !== undefined && search === '' && prevSearch !== search)) {
            if (timeoutRef.current !== null) {
                clearTimeout(timeoutRef.current);
            }
            if (search === '') {
                dispatchFilter(sortBy, sortOrder);
            } else {
                timeoutRef.current = setTimeout(() => {
                    timeoutRef.current = null;
                    dispatchFilter(sortBy, sortOrder);
                }, 500);
            }
        }
    }, [search]);

    useEffect(() => {
        if (roleManagement !== '') {
            if (checkViewPermission('Other Taxes', history, moduleType ? moduleType : 'Younote Admin')) {
                loadTasks();
            }
        }
    }, [roleManagement]);

    const prevGetData = usePrevious(getData); useEffect(() => {
        if (loadMore && getData === '') {
            setLoadMoreContent(false);
            setLoadMore(true);
        }
        if (prevGetData !== undefined && getData && prevGetData !== getData) {
            const timer = setTimeout(() => {
                if (getData && Array.isArray(getData) && getData?.length > 0) {
                    setLoadMore(true);
                    if (getData?.length < limit) {
                        setLoadMoreContent(false);
                    } else {
                        setLoadMoreContent(true);
                    }
                } else {
                    setLoadMoreContent(false);
                    setLoadMore(true);
                }
            });

            return () => {
                clearTimeout(timer);
            };
        }
    }, [getData]);

    const dispatchFilter = (sortBy, sortOrder, skip = 0) => {
        if (skip === 0) {
            setLoadMore(false);
            setLoadMoreContent(false);
        }
        let filter = { ["or"]: [] };
        if (search !== '') {
            filter['or'].push({ taxType: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ name: { like: '%' + search.trim() + '%' } });
            filter['or'].push({ percentage: { like: '%' + search.trim() + '%' } });
        }
        setSkip(skip);
        dispatch({
            type: crudActions.GET_DETAILS_START,
            url: 'othertaxes',
            skip: skip,
            filter: {
                where: filter,
                order: sortBy + ' ' + sortOrder,
                limit: limit,
                skip: skip,
            }
        });
    }

    const loadTasks = useCallback(() => {
        dispatchFilter(sortBy, sortOrder);
    });

    const createOtherTaxes = (e) => {
        e.preventDefault();
        let emptyType = emptyValidation('Type', form?.taxType);
        let emptyCode = emptyValidation('Name', form?.name);
        let emptyPercentage = emptyValidation('Percentage', form?.percentage);
        setError({});
        if (emptyType.isValid && emptyCode.isValid && emptyPercentage.isValid) {
            form.percentage = form.percentage ? parseFloat(form.percentage) : 0;
            form.threshold = form.threshold ? parseFloat(form.threshold) : 0;
            dispatch({
                type: form?.id ? crudActions.EDIT_DETAILS_START : crudActions.CREATE_DETAILS_START,
                url: 'othertaxes',
                title: 'Other Taxes',
                id: form?.id,
                details: form
            });
        } else {
            setError({
                type: emptyType?.errors || false,
                code: emptyCode?.errors || false,
                percentage: emptyPercentage.errors || false
            })
        }
    }
    useEffect(() => {
        if (prevCreateDetails !== undefined && createDetails && prevCreateDetails !== createDetails) {
            dispatchFilter(sortBy, sortOrder);
            setVisible(false);
            toast.dismiss();
            toast(createDetails);
            setForm({});
            if (addMore) {
                setAddMore(false);
                setTimeout(function () {
                    setVisible(true);
                }, 500)
            }
        } else if (prevCreateError !== undefined && createError && prevCreateError !== createError) {
            let error = createError.error.message.split("|");
            if (error[0] === 'name') {
                setError({
                    code: error[1]
                });
            }
            if (error[0] === 'percentage') {
                setError({
                    percentage: error[1]
                });
            }
        }
    }, [createDetails, createError]);


    useEffect(() => {
        if (prevEditDetails !== undefined && editDetails && prevEditDetails !== editDetails) {
            loadTasks();
            toast.dismiss();
            toast(editDetails);
            setVisible(false);
        } else if (prevEditError !== undefined && editError && prevEditError !== editError) {
            let error = editError.error.message.split("|");
            if (error[0] === 'name') {
                setError({
                    code: error[1]
                });
            }
            if (error[0] === 'percentage') {
                setError({
                    percentage: error[1]
                });
            }
        }
    }, [editDetails, editError, prevEditDetails, prevEditError]);

    const handleAddMore = (e) => {
        createOtherTaxes(e);
        setAddMore(true);
    }


    const requestSort = (sortBy, sortOrder) => {
        setSortBy(sortBy);
        setSortOrder(sortOrder);
        dispatchFilter(sortBy, sortOrder);
    }

    const loadMoreTask = () => {
        let s = skip + limit;
        dispatchFilter(sortBy, sortOrder, s);
    }

    const loadImportExportData = (name, data = 'existing', selected = [], extension = 'xlsx') => {
        dispatch({
            type: crudActions.EXPORT_START,
            export: name,
            data: data,
            selected: selected,
            extension: extension,
            url: 'othertaxes',
            filter: {
                order: sortBy + ' ' + sortOrder,
            }
        });
    }

    const onEdit = (data, view) => {
        setForm(data); setView(view); setVisible(true);
    }

    const changeHandler = (e, name = '') => {
        if (name !== '') {
            setForm({
                ...form, [name]: e
            })
        } else {
            setForm({
                ...form, [e.target.name]: e.target.value
            })
        }
    }

    const customObject = (details, id) => {
        let a = details && details.filter((el) => { return el.id === id });
        if (a && a?.length !== 0) {
            return a[0];
        }
        return [];
    }

    const classes = customStyles();
    return (
        <React.Fragment>
            <MainHeader  {...props}
                img={SettingsImg}
                title={moduleType ? moduleType : 'Younote Admin'} links={[{ 'label': moduleType ? moduleType : 'Younote Admin', 'link': moduleType === 'Admin' ? '/admin' : '/younote-admin' }]} />
            <div className={clsx(classes.margin40, classes.listTableMargin)}>
                <PrimaryCard
                    title={'Other Taxes-Maintenance'}
                    component={
                        <>
                            <Row align="middle" className={classes.marginBottom20}>
                                <Col xxl={6} xl={7} lg={8} md={10} sm={13} xs={24}>
                                    {
                                        roleManagement !== '' && checkComponentPermission('Other Taxes', 'Action', 'Search') &&
                                        <div className={clsx(classes.searchAnimation, { [classes.iconAnimation]: iconAnimation })}>
                                            <TextField autoComplete='one-time-code'
                                                placeholder='Search'
                                                type='search'
                                                className={classes.comInput}
                                                required
                                                variant={'standard'}
                                                onChange={(e) => setSearch(e.target.value)}
                                                // onChange={(e) => setPassword(e.target.value)}
                                                fullWidth
                                                onFocus={() => setIconAnimation(true)}
                                                onBlur={() => setIconAnimation(false)}
                                            />
                                            <Image
                                                src={SearchIcon}
                                                preview={false}
                                            />
                                        </div>
                                    }
                                </Col>
                                <Col xxl={18} xl={17} lg={16} md={14} sm={11} xs={24} className={clsx(classes.textAlignRight, classes.allCustomerTop)}>
                                    <div className={classes.overlFlowResponsiveDesign}>
                                        <Space size={[20, 20]} direction="horizontal" align="center">
                                            {
                                                roleManagement !== '' && checkComponentPermission('Other Taxes', 'Action', 'Export') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { loadImportExportData('OtherTaxes'); }}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={ExportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Export</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Other Taxes', 'Action', 'Import') &&
                                                <NavLink
                                                    to="#"
                                                    onClick={() => { setImportVisible(true); }}
                                                    className={clsx(classes.customLink)}>
                                                    <Image
                                                        src={ImportIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Import</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkCRUDPermission('Other Taxes', 'create', moduleType ? moduleType : 'Younote Admin') &&
                                                <NavLink
                                                    to={'#'}
                                                    onClick={() => handleOpen()}
                                                    className={clsx(classes.customLink)}
                                                >
                                                    <Image
                                                        src={AddIcon}
                                                        preview={false}
                                                        className={clsx(classes.antImage)}
                                                    /> <span className={clsx(classes.addLink, classes.color, classes.bold)}>Add Other Taxes</span>
                                                </NavLink>
                                            }
                                            {
                                                roleManagement !== '' && checkComponentPermission('Other Taxes', 'Action', 'Filter') &&
                                                <></>
                                            }
                                        </Space>
                                    </div>
                                </Col>
                            </Row>

                            <OtherTaxesTable
                                {...props}
                                loadTasks={() => dispatchFilter(sortBy, sortOrder)}
                                details={getList}
                                loadMore={loadMore}
                                loadMoreContent={loadMoreContent}
                                loadMoreTask={() => loadMoreTask()}
                                sortOrder={sortOrder} sortBy={sortBy}
                                roleManagement={roleManagement}
                                onEdit={(data) => onEdit(data, false)}
                                view={view}
                                onView={(data) => onEdit(data, true)}
                                onRequestSort={(sortBy, sortOrder) => requestSort(sortBy, sortOrder)} />
                        </>
                    }
                />
                <PrimaryDrawer
                    anchor={'right'}
                    open={visible}
                    variant={'temporary'}
                    handleClose={() => handleClose()}
                    title={`${form?.id ? 'Edit' : 'Add'} Other Taxes`}
                    className={clsx(classes.closeBackGround, classes.width100P)}
                    component={
                        <Box
                            className={clsx(classes.customForm, classes.removeUnderline)}
                            component="form"
                            autoComplete="off"
                            onSubmit={(e) => createOtherTaxes(e)}>
                            <div className={classes.customFormFlex}>
                                <AutoCompleteComponent
                                    name={["Type ", <span key={"Type"} className={classes.colorRedRequired}> *</span>]}
                                    heads={[{ 'key': 'name', 'name': 'name' }]}
                                    details={[{ id: 'TCS', name: 'TCS' }, { id: 'TDS', name: 'TDS' }]}
                                    parentValue={customObject([{ id: 'TCS', name: 'TCS' }, { id: 'TDS', name: 'TDS' }], form?.taxType)}
                                    onChange={(data) => changeHandler(data.id, 'taxType')}
                                    position={'bottom'}
                                    parentError={error?.type}
                                />
                                <TextField autoComplete='one-time-code'
                                    label={["Name ", <span key={"Name"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    name="name"
                                    value={form?.name || ''}
                                    error={error?.name ? true : false}
                                    helperText={error?.name}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    className={clsx(classes.margin30t)}
                                    onChange={(e) => changeHandler(e)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label={["Percentage ", <span key={"Percentage"} className={classes.colorRedRequired}> *</span>]}
                                    variant={'standard'}
                                    type={'number'}
                                    className={clsx(classes.margin30t)}
                                    onWheel={(e) => e.target.blur()}
                                    name="percentage"
                                    value={form?.percentage || ''}
                                    error={error?.percentage ? true : false}
                                    helperText={error?.percentage}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => changeHandler(e)}
                                />
                                <TextField autoComplete='one-time-code'
                                    label={["Threshold "]}
                                    variant={'standard'}
                                    type={'number'}
                                    className={clsx(classes.margin30t)}
                                    onWheel={(e) => e.target.blur()}
                                    name="threshold"
                                    value={form?.threshold || ''}
                                    InputProps={{
                                        classes: {
                                            input: classes.textFieldColor,
                                        }
                                    }}
                                    InputLabelProps={{
                                        className: classes.textFieldLableColorCustom,
                                    }}
                                    onChange={(e) => changeHandler(e)}
                                />
                            </div>
                            <div className={clsx(classes.btnParent)}>
                                <Space direction="horizontal" align="center" size={[10, 10]}>
                                    <Button
                                        key="save"
                                        type='submit'
                                        color='primary'
                                        variant="contained"
                                        className={clsx(classes.modalBtn, { [classes.loading]: createLoader || editLoader })} >
                                        {form?.id ? 'Update & Close' : 'Save & Close'}
                                    </Button>
                                    {
                                        !form?.id && <Button
                                            key="add"
                                            color='primary'
                                            variant="contained"
                                            className={clsx(classes.AddMoreBtn, { [classes.loading]: createLoader || editLoader })}
                                            onClick={(e) => handleAddMore(e)}>
                                            Add more
                                        </Button>
                                    }
                                </Space>
                            </div>
                        </Box>
                    }
                />
            </div>
            <ImportExport
                handleClose={() => { setImportVisible(false); }}
                visible={importVisible}
                title={'OtherTaxes'}
                type={'import'}
                loader={exportLoader}
                loadImportExportData={(name, type, selected, extension) => loadImportExportData(name, type, selected, extension)}
                details={exportDetails}
                loadTasks={() => { dispatchFilter(sortBy, sortOrder) }}
            />
        </React.Fragment >
    )
}
export default OtherTaxes